import _ from "lodash";
// Internal
import { getRating } from "../ratingPrimitives";
import { GPA_ASSOCIATED_CRITERIA_TYPES_ELIGIBLE_FOR_AGGREGATION } from "../constants";

const shouldRoundDecimalPlaces = ({ value, criteriaParentType }) => {
  return (
    _.includes(
      GPA_ASSOCIATED_CRITERIA_TYPES_ELIGIBLE_FOR_AGGREGATION,
      criteriaParentType
    ) && value != "-"
  );
};

export const getAggregateRatingCriteriaSet = ({
  criteriaSet,
  ratings,
  gradingPeriodType,
  termId,
  curriculumType,
  criteriaParentType,
  aggregateParentCriteriaSet,
}) => {
  // Get computed rating
  const computedRating = getRating({
    computedRating: true,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId: aggregateParentCriteriaSet?.id,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  // Get overriding rating
  const overRidingRating = getRating({
    computedRating: false,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId: aggregateParentCriteriaSet?.id,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  const rating = overRidingRating ? overRidingRating : computedRating;

  const value = _.get(rating, "value", "-");

  const roundedValue = shouldRoundDecimalPlaces({
    value,
    criteriaParentType,
  })
    ? _.round(value, 2)
    : value;

  const updatedValue = shouldAddPercentageSuffix({
    value: roundedValue,
    criteriaParentType,
    criteriaSubType: criteriaSet.subType,
  })
    ? `${roundedValue}%`
    : roundedValue;

  return {
    ...criteriaSet,
    value: updatedValue,
    rawAggregatedScore: roundedValue,
  };
};

const shouldAddPercentageSuffix = ({
  value,
  criteriaParentType,
  criteriaSubType,
}) =>
  criteriaParentType == "FINAL_SCORE" &&
  criteriaSubType == "AVERAGE" &&
  value != "-";
